export enum rbacActions {

    GetDashboard = 'GetDashboard',
    ViewGettingStarted = 'ViewGettingStarted',

    ListDomainNames = 'ListDomainNames',
    GetDomainName = 'GetDomainName',
    CreateDomainName = 'CreateDomainName',
    UpdateDomainName = 'UpdateDomainName',
    DeleteDomainName = 'DeleteDomainName',
    BulkImportDomainNames = 'BulkImportDomainNames',

    ListRegistrars = 'ListRegistrars',
    GetRegistrar = 'GetRegistrar',
    CreateRegistrar = 'CreateRegistrar',
    UpdateRegistrar = 'UpdateRegistrar',
    DeleteRegistrar = 'DeleteRegistrar',

    ListTopLevelDomains = 'ListTopLevelDomains',
    GetTopLevelDomain = 'GetTopLevelDomain',
    CreateTopLevelDomain = 'CreateTopLevelDomain',
    UpdateTopLevelDomain = 'UpdateTopLevelDomain',
    DeleteTopLevelDomain = 'DeleteTopLevelDomain',

    ListApplicationProducts = 'ListApplicationProducts',
    GetApplicationProduct = 'GetApplicationProduct',
    CreateApplicationProduct = 'CreateApplicationProduct',
    UpdateApplicationProduct = 'UpdateApplicationProduct',
    DeleteApplicationProduct = 'DeleteApplicationProduct',

    ListSettings = 'ListSettings',
    GetSetting = 'GetSetting',
    UpdateSetting = 'UpdateSetting',
};

export const actions = Object.values(rbacActions);

